export default {
  name: "navbarSearchAndPinList",
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/dashboard',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
